import { Stack } from "@mui/material";
import { RecommendedAccount } from "../../types/apiTypes";
import { TierType } from "../../types/enums";
import { RecommendedGridList } from "./RecommendedGrilList";

type Props = {
  recommendedAccounts: Record<TierType, RecommendedAccount[]>;
};

export const RecommendedGridBlock = ({ recommendedAccounts }: Props) => {
  const tiers = Object.entries(recommendedAccounts);

  const allIds = tiers.reduce(
    (acc, [_, items]) => [...acc, ...items.map(({ id }) => id)],
    [] as string[],
  );

  const isDemo = allIds.length === 0;

  return (
    <Stack gap={"24px"}>
      {isDemo ? (
        <RecommendedGridList
          recommendedAccounts={[]}
          tier={TierType.high}
          isDemo={true}
        />
      ) : (
        tiers.map(([tier, recommendedAccounts]) => (
          <RecommendedGridList
            key={tier}
            recommendedAccounts={recommendedAccounts}
            tier={tier as TierType}
            isDemo={false}
          />
        ))
      )}
    </Stack>
  );
};
